
import { MapLocation } from '@/types/location';

// Wawan Gym Locations
export const wawanGyms: MapLocation[] = [
  {
    id: 1001,
    name: "Wawan Gym - Riyadh (Ar Rabwah)",
    type: "Gym",
    devices: 6,
    coordinates: [24.69884138896727, 46.772597835582346],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "22-45",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
